import { matchesUA } from 'browserslist-useragent'

export const isSupportedBrowser = () => {
  const userAgent = window.navigator.userAgent

  const supportedBrowsers = __SUPPORTED_BROWSERS__ ?? []

  if (!supportedBrowsers.length) {
    return true
  }

  return matchesUA(userAgent, {
    browsers: supportedBrowsers,
    path: '.',
    allowHigherVersions: true,
  })
}
